import FAQFilter from './FAQFilter';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import FAQSwitchChange from '../FAQSwitchChange';

interface FAQ {
    id: number;
    question: string;
    answer: string;
    order: number;
    is_active: boolean;
    created_at: string;
}

interface FAQFilter {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    search: string;
    is_active: string;
}

interface Props {
    faqs: FAQ[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active: (id: number, active: boolean) => void;
    destroy?: (id: number) => void;
    filter: FAQFilter;
    setFilter: (filter: FAQFilter) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const FAQDataTable = ({
    faqs,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Orden',
            selector: (row: any) => row.order,
            sortable: true,
            sortField: 'order',
            width: '80px',
            cell: (row: FAQ, index: any, column: any) => (
                <span className="">{row?.order}</span>
            )
        },
        {
            name: 'Pregunta',
            selector: (row: any) => row.question,
            sortable: true,
            sortField: 'question',
            cell: (row: FAQ, index: any, column: any) => (
                <div style={{ maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {row?.question}
                </div>
            )
        },
        {
            name: 'Respuesta',
            selector: (row: any) => row.answer,
            sortable: false,
            cell: (row: FAQ, index: any, column: any) => (
                <div style={{ maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {row?.answer}
                </div>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: FAQ, index: any, column: any) => (
                <FAQSwitchChange
                    checkValue={row.is_active ?? true}
                    faqId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: FAQ, index: any, column: any) => (
                <div className="d-flex align-items-center">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            title="Editar"
                            classIcon="fa-edit"
                            colorIcon="text-warning"
                            sizeIcon="16"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            title="Eliminar"
                            classIcon="fa-trash"
                            colorIcon="text-danger"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <FAQFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={faqs}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default FAQDataTable;

